import React from 'react';
import { useReturnDialog } from '@modules/es-file/dialog-actions/return/return-hook';
import { Agenda } from '@enums';

export function Toolbar() {
  const { ReturnButton } = useReturnDialog(Agenda.SPR);

  return <ReturnButton />;
}
